export interface TaskTypeMappingResult {
  contentLabel: string;
  pipelineStepName?: string;
  warnings: string[];
}

const TASK_TYPE_LABELS: Record<string, { contentLabel: string; pipelineStepName?: string }> = {
  supervisor: { contentLabel: "supervisor", pipelineStepName: "Supervision" },
  production: { contentLabel: "production", pipelineStepName: "Production" },
  editorial: { contentLabel: "editorial", pipelineStepName: "Editorial" },
  concept: { contentLabel: "concept", pipelineStepName: "Concept" },
  dmp: { contentLabel: "dmp", pipelineStepName: "DMP" },
  comp: { contentLabel: "comp", pipelineStepName: "Comp" },
  roto: { contentLabel: "roto", pipelineStepName: "Roto" },
  prep: { contentLabel: "prep", pipelineStepName: "Prep" },
  gfx: { contentLabel: "gfx", pipelineStepName: "Graphics" },
  cameratr: { contentLabel: "cameraMM", pipelineStepName: "CameraMM" },
  objecttr: { contentLabel: "objectMM", pipelineStepName: "ObjectMM" },
  ranim: { contentLabel: "rotoAnim", pipelineStepName: "RotoANIM" },
  layout: { contentLabel: "layout", pipelineStepName: "Layout" },
  anim: { contentLabel: "anim", pipelineStepName: "Animate" },
  light: { contentLabel: "light", pipelineStepName: "Light" },
  fx: { contentLabel: "FX", pipelineStepName: "FX" },
  model: { contentLabel: "model", pipelineStepName: "Model" },
  rig: { contentLabel: "rig", pipelineStepName: "Rig" },
  retop: { contentLabel: "retop", pipelineStepName: "Retop" },
  cloth: { contentLabel: "cloth", pipelineStepName: "Cloth" },
  fur: { contentLabel: "fur", pipelineStepName: "Fur" },
  groom: { contentLabel: "groom", pipelineStepName: "Groom" },
  texture: { contentLabel: "texture", pipelineStepName: "Texture" },
  lookdev: { contentLabel: "lookdev", pipelineStepName: "Lookdev" },
  photoscan: { contentLabel: "photoscan", pipelineStepName: "Photoscan" },
  review: { contentLabel: "review", pipelineStepName: "Supervision" },
};

function toKey(value?: string | null) {
  return (value || "").trim().toLowerCase().replace(/[^a-z0-9]+/g, "");
}

function titleCase(raw?: string | null) {
  return (raw || "")
    .split(/[\s_-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(" ");
}

export function mapTaskType(taskType?: string | null, pipelineStep?: string | null): TaskTypeMappingResult {
  const warnings: string[] = [];
  const mapped = TASK_TYPE_LABELS[toKey(taskType)] || TASK_TYPE_LABELS[toKey(pipelineStep)];

  if (mapped) {
    return {
      contentLabel: mapped.contentLabel,
      pipelineStepName: mapped.pipelineStepName,
      warnings,
    };
  }

  const fallbackLabel = titleCase(pipelineStep || taskType) || "Task";
  if (taskType || pipelineStep) {
    warnings.push(`Unmapped task type '${pipelineStep || taskType}'. Using '${fallbackLabel}' as the task content label.`);
  }

  return {
    contentLabel: fallbackLabel,
    warnings,
  };
}
